module.exports = __webpack_public_path__ + "img/placeholder.6b2d5b96.png";